import { IcoArrowLeft, IcoClose } from "assets/icons";
import { BaseModal, Button, ModalFooter } from "components";
import Datepicker from "components/Datepicker";
import { ErrorHelper } from "helpers";
import { useIsMobile } from "hooks/useIsMobile";
import { useMemo, useState } from "react";
import { toast } from "react-toastify";
import { ApplicationService } from "services/applicationService";

type Props = {
	applicationId: string;
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
};

export default function ApproveCancellationModal({ applicationId, isOpen, onClose, onSuccess }: Props) {
	const isMobile = useIsMobile();
	const applicationService = useMemo(ApplicationService.getInstance, []);
	const [cancellationDate, setCancellationDate] = useState<Date | null>(null);
	const [loading, setLoading] = useState<boolean>(false);

	const handleConfirm = async () => {
		if (!cancellationDate) {
			toast.warning("Informe a data de cancelamento");
			return;
		}

		setLoading(true);
		try {
			await applicationService.approveCancellation(applicationId, cancellationDate.toISOString());
			toast.success("Cancelamento aprovado com sucesso");
			onClose();
			onSuccess?.();
		} catch (error) {
			toast.error(ErrorHelper.getResponseErrorMessage(error));
		} finally {
			setLoading(false);
		}
	};

	return (
		<BaseModal onClickOutsideModal={onClose} isOpen={isOpen} contentClassName="rounded-xl overflow-hidden" bodyClassName="!px-6 !py-6 !gap-4">
			{isMobile && (
				<div className="flex justify-start px-6 py-2 border-b-2 border-neutral-high-100">
					<button onClick={onClose} aria-label="voltar">
						<IcoArrowLeft size="24" />
					</button>
				</div>
			)}

			<div className="flex justify-between items-center px-1">
				<div className="font-heading-semibold-tiny">Aprovar cancelamento</div>
				{!isMobile && (
					<Button kind="icon" hierarchy="ghost" onClick={onClose}>
						<IcoClose />
					</Button>
				)}
			</div>

			<div className="flex flex-col gap-6 px-1 overflow-y-auto">
				<div className="font-neutral-low-400">
					Confirme a data para o cancelamento da isenção. Esta ação enviará a notificação ao sistema.
				</div>

				<Datepicker
					label="Data do cancelamento"
					selectedDate={cancellationDate}
					onChange={(date: Date) => setCancellationDate(date)}
					isRequired
				/>

				<ModalFooter>
					<Button hierarchy="secondary" size="medium" onClick={onClose}>
						Cancelar
					</Button>
					<Button hierarchy="primary" size="medium" onClick={handleConfirm} disabled={!cancellationDate} isLoading={loading}>
						Confirmar
					</Button>
				</ModalFooter>
			</div>
		</BaseModal>
	);
}
